import { render, staticRenderFns } from "./CardRegione.vue?vue&type=template&id=8f76b848&scoped=true&"
import script from "./CardRegione.vue?vue&type=script&lang=js&"
export * from "./CardRegione.vue?vue&type=script&lang=js&"
import style0 from "./CardRegione.vue?vue&type=style&index=0&id=8f76b848&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f76b848",
  null
  
)

export default component.exports